import { render, staticRenderFns } from "./CategoryField.vue?vue&type=template&id=526134d7&"
import script from "./CategoryField.vue?vue&type=script&lang=js&"
export * from "./CategoryField.vue?vue&type=script&lang=js&"
import style0 from "./CategoryField.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports